import { Table } from "antd";
import Loader from "components/loader";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { routesNames } from "utils/Constants";
import { getFullDay, getFullMonth } from "utils/Utils";
import { getPostulacionesByUsuario } from "services/Usuarios";

const columns = [
  {
    title: "Institución",
    dataIndex: "cuenta",
    render: (text, record) => (
      record?.cuenta?.user_id ? (
        <Link to={`${routesNames.USER}/${record.cuenta.user_id}`} className="text-sm font-semibold text-blue-800 dark:text-white">
          {record.cuenta.nombre}
        </Link>
      ) : (
        record?.cuenta?.nombre || "—"
      )
    ),
  },
  {
    title: "Publicación",
    dataIndex: "publicacion",
    render: (text, record) => (
      record?.publicacion_id ? (
        <Link to={`${routesNames.PUBLICATION}/${record.publicacion?.id}`} className="text-sm font-semibold text-blue-800 dark:text-white">
          {record.publicacion?.nombre}
        </Link>
      ) : (
        <span className="text-sm text-gray-600 dark:text-gray-400">Espontánea</span>
      )
    ),
  },
  {
    title: "Fecha",
    dataIndex: "created_at",
    render: (text) => {
      const date = new Date(text);
      return `${getFullDay(date, true)}/${getFullMonth(date)}/${date.getFullYear()}`;
    },
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    defaultSortOrder: "descend",
  },
];

const PostulacionesTable = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!userId) return;

    const fetchPostulaciones = async () => {
      setIsLoading(true);
      const data = await getPostulacionesByUsuario(userId);
      setRows(Array.isArray(data) ? data : []);
      setIsLoading(false);
    };

    fetchPostulaciones();
  }, [userId]);

  const espontaneas = useMemo(() => rows.filter((item) => !item?.publicacion_id).length, [rows]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <span className="mb-2 block text-sm font-semibold text-start">
        {rows.length} postulaciones encontradas ({espontaneas} espontáneas)
      </span>

      <Table
        dataSource={rows}
        columns={columns}
        rowKey={(record) => record.id}
        size="small"
        pagination={{ pageSize: 10, showSizeChanger: false }}
        locale={{ emptyText: "No hay postulaciones" }}
      />
    </>
  );
};

export default PostulacionesTable;
